module.exports = __webpack_public_path__ + "static/media/file-upload.0ae441d0.svg";